import makeApi from "../../libs/axios/api";
import {
  ImageDetails,
  ImagesPayload,
} from "../../types/orderhistoryimage";
const apiPromise = makeApi();


const getOrderHistoryImage = async (
  data: ImagesPayload
): Promise<ImageDetails> => {
  const api = await apiPromise;

  const params = new URLSearchParams({
    orderId: data.orderId?.toString() || "0",
    orderAttachmentId: data.orderAttachmentId?.toString() || "0",
  });
 
  const path = `/order/attachment?${params.toString()}`;
 
  return api.get(path).then((response) => {
    const blob = response; // ✅ NOT res.blob()
    const url = URL.createObjectURL(blob.data);
    const images = {
      fileUrl: url
    }
    return images;
  });
};
export default getOrderHistoryImage;
